import { render } from "./TimetableView.vue?vue&type=template&id=c6580f66"
import script from "./TimetableView.vue?vue&type=script&lang=js"
export * from "./TimetableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__